import styled from 'styled-components';
import { Text } from '@dls/web';

export const Container = styled.div`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  overflow: auto;
`;

export const AccountText = styled(Text)`
  color: white;
  white-space: nowrap;
`;
